import { render, staticRenderFns } from "./FormIT2104.vue?vue&type=template&id=778593a2&scoped=true&"
import script from "./FormIT2104.vue?vue&type=script&lang=ts&"
export * from "./FormIT2104.vue?vue&type=script&lang=ts&"
import style0 from "./FormIT2104.vue?vue&type=style&index=0&id=778593a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "778593a2",
  null
  
)

export default component.exports